import React, { useEffect } from "react"
import { useValidatorSeeker } from "@ui-seeker/app"
import { number, object } from "yup"

import { BACKEND_APIS } from "@constants"
import { AppSitesAutocomplete } from "@components"
import { useAlertsDataInfo } from "Pages/ReportsAlerts/Alerts/Conditions/@hooks"
import { alertsDrawerData, alertsDrawerErrors } from "Pages/ReportsAlerts/Alerts/Conditions/@signals"


export default function AlertsMainSites() {

	const { dataInfo, setDataInfo } = useAlertsDataInfo(alertsDrawerData.peek().idMainSite || null)

	const { errors, isValid } = useValidatorSeeker({ idMainSite: dataInfo.value }, object({
		idMainSite: number().required('Must provide at least one main site')
	}))

	useEffect(() => {
		alertsDrawerErrors.value = { ...alertsDrawerErrors.value, idMainSite: isValid }
	}, [JSON.stringify(errors)])

	return <AppSitesAutocomplete
		multiple={false}
		label="Main site"
		placeholder="Select one main site"
		value={dataInfo.value}
		onChange={e => setDataInfo(e.target.value, 'idMainSite')}
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/options/site`}
		error={errors?.idMainSite}
	/>
}